<template>
  <div id="app">
    <keep-alive>
      <router-view :key="$route.fullPath" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view :key="$route.fullPath" v-if="!$route.meta.keepAlive"></router-view>
    <!-- <div style="position: fixed;bottom: 0px;width: 100%;height: 100px;background: white;padding: 0px;margin: 0px;left: 0px;"></div> -->
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>

<script>
import { mapState } from 'vuex';
import request from "./axios/request";
import router from './router';
document.addEventListener('gesturestart', function (event) {
  event.preventDefault()
})
export default {
  computed: {
    ...mapState([
      'socket',
      'showMessageDialog',
      'messageDialogContent',
      'dialogMessageType'
    ])
  },
  data() {
    return {
      tokenId: null,
      cleanupFunctions: [],
      timers: {
        reconnectTimer: null,
        heartbeatTimer: null,
        checkTimer: null
      },
      _listenersBound: false
    }
  },
  watch: {

    // 深度监听 messageList 的变化
    showMessageDialog: {
      handler(newVal, oldVal) {
        if (newVal == null) {
          return
        }
        let title = null
        let duration = null
        let routerPath = null
        if (this.dialogMessageType == 0) {
          title = "收到一条消息"
          duration = 3000
          routerPath = '/message/' + newVal
        } else {
          title = "通知"
          duration = 0
          routerPath = '/OrderInfoView/' + newVal
        }

        this.$store.state.showMessageDialog = null
        let notifyItem = this.$notify({
          title: title,
          message: this.messageDialogContent,
          duration: duration,
          showClose: false,
          onClick: () => {
            this.$router.push(routerPath)
            notifyItem.close()
          }
        });

        // 这里可以执行一些数据变化后的操作
      },
      deep: true,  // 深度监听
    }
  },
  created() {
    this.initEventListeners();
  },
  mounted() {
    document.title = "乘风速购"
    this.init()
  },
  beforeDestroy() {
    // 非常重要：组件销毁时清理所有资源
    this.cleanup();
  },
  deactivated() {
    // 如果是 keep-alive 缓存的组件，会触发 deactivated
    this.clearTimers();
  },
  activated() {
    // 从缓存中激活时，重新初始化连接检查
    if (this.socket && this.socket.readyState !== WebSocket.OPEN) {
      this.checkConnection();
    }
  },
  methods: {
    async initCurrent() {
      try {
        let senderType = 0;
        let sendToken = localStorage.getItem("token");

        let map = {
          wsId: this.tokenId,
          sendToken: sendToken,
          senderType: senderType,
          op: "initCurrent",
        };

        this.$store.commit("initWs", map);
      } catch (error) {
        console.error("初始化连接失败:", error);
      }
    },
    async init() {
      await this.connectWs()
    },
    initEventListeners() {
      // 避免重复绑定，先检查是否已绑定
      if (this._listenersBound) return;

      const handleVisibilityChange = this.handleVisibilityChange.bind(this);
      const handleBeforeUnload = this.handleBeforeUnload.bind(this);

      document.addEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('beforeunload', handleBeforeUnload);

      // 存储清理函数
      this.cleanupFunctions.push(() => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        window.removeEventListener('beforeunload', handleBeforeUnload);
      });

      this._listenersBound = true;
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        this.debouncedCheckConnection();
      }
    },
    // 防抖的连接检查
    debouncedCheckConnection() {
      this.clearTimers('checkTimer');

      this.timers.checkTimer = setTimeout(() => {
        this.checkConnection();
      }, 100);
    },
    // 检查连接状态
    checkConnection() {
      if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
        console.log('连接已断开，尝试重连...');
        this.reconnect();
      }
    },
    reconnect() {
      this.initCurrent().catch(error => {
        console.error("重连失败:", error);

        // 指数退避重连
        this.scheduleReconnect();
      });
    },

    // 安排重连（指数退避）
    scheduleReconnect(attempt = 1) {
      const maxAttempts = 5;
      const baseDelay = 1000; // 1秒
      const maxDelay = 30000; // 30秒

      if (attempt > maxAttempts) {
        console.log("达到最大重连次数");
        return;
      }

      const delay = Math.min(baseDelay * Math.pow(2, attempt - 1), maxDelay);

      console.log(`第${attempt}次重连将在${delay}ms后尝试`);

      this.clearTimers('reconnectTimer');

      this.timers.reconnectTimer = setTimeout(() => {
        this.reconnect();
      }, delay);
    },
    // 页面卸载前的处理

    handleBeforeUnload() {
      console.log('页面即将卸载，清理资源');
      // this.cleanup();
    },
    // 清理所有定时器
    clearTimers(timerName = null) {
      if (timerName) {
        // 清理指定定时器
        if (this.timers[timerName]) {
          clearTimeout(this.timers[timerName]);
          clearInterval(this.timers[timerName]);
          this.timers[timerName] = null;
        }
      } else {
        // 清理所有定时器
        Object.keys(this.timers).forEach(key => {
          if (this.timers[key]) {
            clearTimeout(this.timers[key]);
            clearInterval(this.timers[key]);
            this.timers[key] = null;
          }
        });
      }
    },
    cleanup() {
      console.log('执行清理操作');

      // 1. 清理所有定时器
      this.clearTimers();

      // 2. 移除事件监听器
      this.cleanupFunctions.forEach(cleanup => {
        try {
          cleanup();
        } catch (error) {
          console.error('清理事件监听器失败:', error);
        }
      });
      this.cleanupFunctions = [];

      // 3. 重置标记
      this._listenersBound = false;

      // 4. 关闭WebSocket连接
      if (this.socket) {
        try {
          this.socket.close(1000, '组件销毁');
        } catch (error) {
          console.error('关闭WebSocket失败:', error);
        }
        this.socket = null;
      }
    },

    async connectWs() {

      let resOfGetRandomId = await request({
        url: "/user/api/getRandomId",
        method: "GET",
      });
      if (resOfGetRandomId.data.status == 200 && this.tokenId == null) {
        this.tokenId = resOfGetRandomId.data.data;
        console.log("开始连接");

      }
      await this.initCurrent()
    },

  }
}
</script>
